import {
  type ComponentProps,
  type MouseEvent,
  type Ref,
  useCallback,
} from "react";
import { TableCell as BaseTableCell } from "~/components/ui/table";
import { cn } from "~/utils";
import { ColumnDef } from "./column";

export interface TableCellProps extends ComponentProps<typeof BaseTableCell> {
  columnDef?: ColumnDef<any>;
}

export function TableCell({
  columnDef,
  onClick,
  ref,
  ...props
}: TableCellProps & { ref?: Ref<HTMLTableCellElement> }) {
  const onCellClick = useCallback(
    (event: MouseEvent<HTMLTableCellElement>) => {
      if (columnDef?.ignoreColumnClick) {
        event.stopPropagation();
        return;
      }

      return onClick?.(event);
    },
    [columnDef?.ignoreColumnClick, onClick],
  );

  return (
    <BaseTableCell
      ref={ref}
      {...props}
      className={cn("h-12 font-normal whitespace-nowrap", props.className)}
      onClick={columnDef?.ignoreColumnClick ? onCellClick : onClick}
    />
  );
}

TableCell.displayName = "TableCell";
